import Modal from "./hack";
export { default as useModal } from "./hack/useModal";
export default Modal;